import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Header = styled.section`
  width: 100%;
  margin-bottom: 2rem;
`;

interface Props {
  startDate: Date | null;
  endDate: Date | null;
  handleStartDateChange: (date: Date | null) => void;
  handleEndDateChange: (date: Date | null) => void;
}

const DateRange: React.FC<Props> = ({
  startDate,
  endDate,
  handleEndDateChange,
  handleStartDateChange,
}) => {
  return (
    <Header>
      <p style={{ fontWeight: 600, fontSize: "1.3rem" }}>Date Range:</p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "2rem",
          marginTop: "2rem",
        }}
      >
        <div>
          <p
            style={{
              fontSize: ".9rem",
              fontWeight: 600,
              marginBottom: ".25rem",
            }}
          >
            Start Date
          </p>
          <DatePicker
            selected={startDate}
            // @ts-ignore
            maxDate={endDate} // Prevents selecting a start date after the end date
            // onChange={(date) => setStartDate(date)}
            onChange={handleStartDateChange}
            className="date-picker-input"
          />
        </div>
        <div>
          <p
            style={{
              fontSize: ".9rem",
              fontWeight: 600,
              marginBottom: ".25rem",
            }}
          >
            End Date
          </p>
          <DatePicker
            selected={endDate}
            // @ts-ignore
            minDate={startDate}
            // onChange={(date) => setEndDate(date)}
            onChange={handleEndDateChange}
            className="date-picker-input"
          />
        </div>
      </div>
    </Header>
  );
};

export default DateRange;
